import { atom } from 'jotai';

const homeSurveyFormData = atom({
  isHomeSurveyContactButtonClicked: false,
});

export default homeSurveyFormData;
